module.exports = __webpack_public_path__ + "img/bg_m2go@2x.52c94cc1.jpg";